export default __webpack_public_path__ + "static/210526_妲絲刷關活動熱更完成_jp-4ec40b98b751c8ccc6085dd37e630fb6.png";